import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFrown, faMeh, faSmile, faStar } from '@fortawesome/free-solid-svg-icons';

const TrackRating = ({ totalstar, showratingValue, defaultvalue = null, updaterating }) => {
    const [selectedStar, setSelectedStar] = useState(defaultvalue ? defaultvalue : 0);

    const OnStarClick = (StarNumber) => {
        setSelectedStar(StarNumber);
        var stars = document.querySelectorAll(".starfade");
        for (let i = 0; i < stars.length; i++) {
            stars[i].classList.remove("starActive");
        }

        Array.from({ length: StarNumber }).map((star, index) => (
            document.getElementById("star" + index).classList.add("starActive")
        ))
    };

    const UpdateRating = () => {
        updaterating(selectedStar);
    };

    const SmileyType = () => {
        var smileyColor = "";
        var smiley = null;
        if (totalstar === 5) {
            smileyColor = (selectedStar >= 4 ? "#1a8f04" : (selectedStar < 4 && selectedStar >= 3 ? "#e69500" : "#fe1100"));
            smiley = (selectedStar >= 4 ? faSmile : (selectedStar < 4 && selectedStar >= 3 ? faMeh : faFrown));
        }
        else {
            smileyColor = (selectedStar >= 8 ? "#1a8f04" : (selectedStar < 8 && selectedStar >= 5 ? "#e69500" : "#fe1100"));
            smiley = (selectedStar >= 8 ? faSmile : (selectedStar < 8 && selectedStar >= 5 ? faMeh : faFrown));
        }

        return <FontAwesomeIcon style={{
            margin: "1px 5px", fontSize: "30px",
            color: smileyColor
        }} icon={smiley}>
        </FontAwesomeIcon>
    }

    return (
        <div className='row'>
            <div className='col-md-6 col-12 text-right'>
                {Array.from({ length: totalstar }).map((star, index) => (
                    <span onClick={() => OnStarClick(index + 1)} id={`star${index}`} key={index} className=" cursor starfade starDistance"><FontAwesomeIcon icon={faStar}></FontAwesomeIcon></span>
                ))}
            </div>
            <div className='col-md-1 col-6'>
                {showratingValue && (<div className="ratingText">{selectedStar} / {totalstar}</div>)}
            </div>
            <div className='col-md-1 col-6 text-left' style={{ display: "flex", border: "1px solid #ccc", padding: "4px", borderRadius: "6px" }}>
                <SmileyType></SmileyType>
                <button onClick={UpdateRating} disabled={selectedStar === 0} style={{ fontSize: "1rem", display: "flex" }} className="btn btn-default">
                    <div style={{ fontSize: "20px" }}>Rate</div></button>
            </div>


        </div >
    );
};

export default TrackRating;